<template>
  <div class="landing">
    <h1><img class="logo" src="../assets/logo.png"></h1>
    <h2>Sign up for NILA beta</h2>
    <div class="signup-page" v-if="page == 1">
      <p>Leave your contact details and we will send you an invite to the beta.</p>
      <div class="form-group">
        <input class="form-control" v-model="name" placeholder="Name" required>
      </div>
      <div class="form-group">
        <input class="form-control" v-model="email" placeholder="Email" required type="email">
      </div>
      <div class="form-group">
        <LoadingIndicator v-if="isLoading" />
        <button v-else @click="addEmail(name, email)" class="btn btn-signup" type="button">Request beta invite</button>
      </div>
    </div>
    <div class="signup-page" v-if="page == 2">
      <p>Please tell us about your company</p>
      <div class="form-group">
        <input class="form-control" v-model="company" placeholder="Company name">
      </div>
      <div class="form-group">
        <label for="language">Primary business language</label>
        <select class="form-control" v-model="language" id="language" required>
          <option value="en">English</option>
          <option value="jp">Japanese</option>
          <option value="th">Thai</option>
          <option value="other">Other</option>
        </select>
      </div>
      <div class="form-group">
        <label style="display: block">Tools used</label>
        <div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" v-model="tools" id="toolJira" value="jira">
            <label class="form-check-label" for="toolJira">Jira</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" v-model="tools" id="toolTrello" value="trello">
            <label class="form-check-label" for="toolTrello">Trello</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" v-model="tools" id="toolAsana" value="asana">
            <label class="form-check-label" for="toolAsana">Asana</label>
          </div>
        </div>
        <div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" v-model="tools" id="toolLine" value="line">
            <label class="form-check-label" for="toolLine">LINE</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" v-model="tools" id="toolSlack" value="slack">
            <label class="form-check-label" for="toolSlack">Slack</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" v-model="tools" id="toolOther" value="other">
            <label class="form-check-label" for="toolOther">Other:</label>
            <input class="form-control form-control-sm form-control-inline" type="text" v-model="toolsOther" placeholder="List all">
          </div>
        </div>
      </div>
      <div class="form-group">
        <LoadingIndicator v-if="isLoading" />
        <button v-else @click="addOther(company, language, tools, toolsOther)" type="button" class="btn btn-signup">Finish</button>
      </div>
    </div>
    <div class="signup-page" v-if="page == 3">
      <h3>Thank you, {{name}}</h3>
      <p>We will inform you when NILA beta is ready!</p>
    </div>
    <hr>
    <footer>
      <div class="mb-1">Follow us...</div>
      <div class="line-it-button" data-lang="en" data-type="friend" data-lineid="@nilateams" style="display: none;"></div>
    </footer>
  </div>
</template>

<script>
import { db } from '../main'
import firebase from 'firebase/app'
import 'firebase/firestore'
import LoadingIndicator from './LoadingIndicator.vue'

export default {
  name: 'Landing',
  components: {
    LoadingIndicator
  },
  data () {
    return {
      isLoading: false,
      page: 1,
      email: '',
      name: '',
      company: '',
      language: '',
      tools: [],
      toolsOther: '',
      prospectId: ''
    }
  },
  methods: {
    addEmail (name, email) {
      this.isLoading = true
      const doc = { name, email, createdAt: firebase.firestore.FieldValue.serverTimestamp() }
      db.collection('prospects').add(doc).then((docRef) => {
        this.prospectId = docRef.id
        this.page = 2
        this.isLoading = false
      }).catch((error) => {
        console.error('Error adding document: ', error)
        this.isLoading = false
      })
    },
    addOther (company, language, tools, toolsOther) {
      if (this.prospectId === '') {
        return
      }
      this.isLoading = true
      const doc = { company, language, tools, toolsOther }
      db.collection('prospects').doc(this.prospectId).update(doc).then((docRef) => {
        this.page = 3
        this.isLoading = false
      }).catch((error) => {
        console.error('Error updating document: ', error)
        this.isLoading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
html,
body {
  height: 100%;
}

body {
  background-image: url(../assets/bg.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-color: #1aa6b7;
  padding: 5% 15% 5% 55%;
}

@media only screen and (max-width: 700px) {
  body {
    background-image: none;
    padding: 10% 10% 10% 10%;
  }
}

h1 {
  margin-bottom: 40px;
}

img.logo {
  width: 250px;
  max-width: 100%;
}

.signup-page {
  min-height: 280px;
  margin: 40px 0;
}

input.form-control {
  background-color: white;
}

input.form-control.form-control-inline {
  display: inline-block;
  width: 100px;
  margin-left: 1em;
}

button.btn.btn-signup {
  background-color: white;
  color: #1aa6b7;
  font-weight: 900;
  border: none;
  text-transform: uppercase;
  padding-left: 1em;
  padding-right: 1em;
}

button.btn.btn-signup:hover {
  background-color: white;
  border: none;
}

footer {
  font-size: 0.9em;
  text-align: right;
  margin-bottom: 40px;
}

@media only screen and (max-width: 700px) {
  .signup-page {
    min-height: initial;
  }
  footer {
    min-height: 225px;
    background-image: url(../assets/bg-portrait.png);
    background-position: bottom left;
    background-repeat: no-repeat;
    background-size: 250px 201px;
    overflow: visible;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue